/* tslint:disable */
/* eslint-disable */
/**
 * Hey Pharamcist API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { UserGroup } from './user-group';
/**
 * 
 * @export
 * @interface UpdateUserDto
 */
export interface UpdateUserDto {
  _id?: string;
    /**
     * 
     * @type {Date}
     * @memberof UpdateUserDto
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdateUserDto
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    firstname?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    lastname?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    password?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserDto
     */
    isEmailVerified?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    role?: UpdateUserDtoRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    phoneNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof UpdateUserDto
     */
    dateOfBirth?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdateUserDto
     */
    lastActive?: Date;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    storeId?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    customerType?: UpdateUserDtoCustomerTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateUserDto
     */
    adminStores?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserDto
     */
    isEmailNotifActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserDto
     */
    isSmsNotifActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserDto
     */
    alertOnUserRegistration?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserDto
     */
    alertOnOrderCreation?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserDto
     */
    alertOnOrderDelivery?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserDto
     */
    alertOnNewReview?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserDto
     */
    isActive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserDto
     */
    isBlocked?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserDto
     */
    isTaxExempted?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    stripeCustomerId?: string;
    /**
     * ISO 3166-1 alpha-2 country code ... examples -> https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
     * @type {string}
     * @memberof UpdateUserDto
     */
    country?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserDto
     */
    availableCreditBalance?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserDto
     */
    creditLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateUserDto
     */
    creditUsed?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserDto
     */
    isAllowedtToUseCredit?: boolean;
    /**
     * 
     * @type {Array<UserGroup>}
     * @memberof UpdateUserDto
     */
    groups?: Array<UserGroup>;
}

/**
    * @export
    * @enum {string}
    */
export enum UpdateUserDtoRoleEnum {
    SuperAdmin = 'SuperAdmin',
    Admin = 'Admin',
    User = 'User'
}
/**
    * @export
    * @enum {string}
    */
export enum UpdateUserDtoCustomerTypeEnum {
    B2B = 'B2B',
    Regular = 'Regular'
}

